import EF from 'ef/ef';
import Chaplin from 'chaplin';
import Module from 'ef/models/module';
import _ from 'lodash';

// # EF.Collections.ModulesCollection
//
// the ModulesCollection is responsible a just a grouping of module objects.
//
const ModulesCollection = Chaplin.Collection.extend({
  model: Module,

  modelId: function (attrs) {
    return attrs.key;
  },

  comparator: 'index',

  url: function () {
    return EF.ContentProvider.ModulesCollectionService.getModuleCollectionUrl();
  },

  // returns module by key
  getModuleByKey: function (key) {
    return this.find(function (module) {
      return module.get('key') === key;
    });
  },

  getStartingModule: function () {
    const firstNotComplete = EF.modules.findWhere(function (mod) {
      return !mod.isComplete();
    });

    if (firstNotComplete) {
      return firstNotComplete;
    } else {
      return false;
    }
  },

  getFirstAvailable: function (menu) {
    let firstIncomplete;
    if (menu.groups) {
      firstIncomplete = EF.groups.currentGroup().getStartingModule();
    } else {
      firstIncomplete = EF.modules.getStartingModule();
    }
    if (!firstIncomplete && EF.module) {
      firstIncomplete = EF.modules.at(EF.module.get('index') + 1);
    }
    return firstIncomplete;
  },

  firstIncomplete: function () {
    return this.find(function (mod) {
      return !mod.isComplete();
    });
  },

  currentModule: function () {
    return this.firstIncomplete() || this.last();
  },

  lockModules: function (dateStatus) {
    const currentModule = this.currentModule();
    let currentModuleFound = false;
    this.each(function (mod) {
      if (!currentModuleFound) {
        currentModuleFound = mod === currentModule;
        mod.set('locked', false);
      } else {
        mod.set('locked', !mod.get('completed'));
      }
      mod.set('dateStatus', dateStatus);
    });
  },

  syncActivityAndPageProgress: function (activityProgresses) {
    this.each(function (mod) {
      const ap = activityProgresses.findWhere({ module_key: mod.get('key') });
      if (ap) {
        mod.completeAllPages();
      }
    });
  },
  syncModuleProgress: function () {
    // For modules with optional pages
    this.each(mod => {
      mod.get('activities').each(activity => {
        const lastCompletedPage = activity.completedPages().slice(-1)[0];
        lastCompletedPage && activity.completeUpToPage(lastCompletedPage);
      });
    });
  },
  completedModuleCount: function () {
    const completedModules = this.filter(mod => !mod.get('skip_activity_progress') && mod.isComplete());
    return completedModules.length;
  },

  parse: function (response) {
    const modulesAttrs = [];
    const modStatuses = EF.ContentProvider.ModulesCollectionService.getModuleCollectionResponseData(response);
    _.each(this.content_modules, (mod, i) => {
      mod = _.cloneDeep(mod);
      if (!mod.index) {
        mod.index = i;
      }
      const modStatus = EF.ContentProvider.ModulesCollectionService.getModuleCollectionModuleStatusByKey(
        modStatuses,
        mod.key
      );
      if (modStatus) {
        _.extend(mod, modStatus);
      }
      modulesAttrs.push(mod);
    });

    return modulesAttrs;
  },
});

export default ModulesCollection;
